import moment from "moment";


export const parseHour = date => moment(date).format('h:mm a')

export const parseDate = date => moment(date).format('DD/MM/YYYY')

export const parseDateTime = date => new Date(date).toLocaleString()
